import { render, staticRenderFns } from "./Liability.vue?vue&type=template&id=8580a8f2&"
import script from "./Liability.vue?vue&type=script&lang=ts&"
export * from "./Liability.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports